/** @jsx jsx */
import React from 'react'
import { calcRem } from 'component-library/__styling/style-functions'
import { metrics } from 'component-library/__styling/settings'

import { jsx } from '@emotion/react'
import { ThemeMargins } from 'component-library/__styling/settings/metrics'
import { useConsentGiven } from 'common/hooks/useConsentGiven'
import { ConsentLevel } from 'common/data/consent/consent.redux'
import { ConsentFallback } from 'component-library/tracking/ConsentFallback/ConsentFallback'

export interface Props {
    link: string
    width?: number
    verticalSpacing?: keyof ThemeMargins
    height?: number
}

const embedLink = '/embed'

const processEmbedLink = (link: string) => {
    if (link.indexOf(embedLink) === -1) {
        return `${link}${embedLink}`
    }
    return link
}

export const isOmny = (link: string) => {
    return link.indexOf('omny.fm') >= 0
}

export const Omny: React.FC<Props> = (props: Props) => {
    const consentGiven = useConsentGiven({
        consentRequiredLevel: ConsentLevel.Analytics | ConsentLevel.Advertising,
    })

    if (!consentGiven) {
        return <ConsentFallback />
    }

    return (
        <iframe
            css={{
                marginBottom:
                    props.verticalSpacing &&
                    calcRem(metrics.thewest.margins[props.verticalSpacing]),
            }}
            width={props.width ? `${props.width}px` : '100%'}
            height={props.height ? `${props.height}px` : '180px'}
            frameBorder={0}
            src={processEmbedLink(props.link)}
            sandbox={'allow-same-origin allow-popups allow-scripts'}
        />
    )
}
